var IpcDataModel = require("./index.js");
var IpcNameHelper = require("./ipcNameHelper.js");
var PackageData = require("../../package/packageData.js");
var MetaDataProperties = require("cio-config").MetaProperties;

var MetaDataUpdateHelper = {};

MetaDataUpdateHelper.updatePackageMetaDataFromIPCParametricData = function(data, name, description, summary, ipcName, override) {
    console.assert(data && data.constructor === PackageData);

    var ipcParametricData = data.ipcParametricData();
    console.assert(ipcParametricData);

    var metaData = data.metaData();

    ////////////////////
    //   Pin count    //
    ////////////////////

    if(!override) {
        if(metaData["pins"]() === null) {
            this.updatePinCount(ipcParametricData, metaData);
        }
    } else {
        this.updatePinCount(ipcParametricData, metaData);
    }
    ///////////////////////////////////////
    //   Name, description and summary   //
    ///////////////////////////////////////

    this.updateNameDescriptionSummary(name, description, summary, metaData, override);

    //////////////////////////////
    //   IPC Name and family    //
    //////////////////////////////

    if(!override) {
        if(metaData["ipcName"]() === null) {
            this.updateIPCName(ipcName, metaData);
        }

        if(metaData["ipcFamily"]() === null) {
            this.updateIPCFamily(ipcParametricData, metaData);
        }
    } else {
        this.updateIPCName(ipcName, metaData);
        this.updateIPCFamily(ipcParametricData, metaData);
    }

    ////////////////////
    //   Pin pitch    //
    ////////////////////

    if(!override) {
        if(metaData["pitch"]() === null) {
            this.updatePitch1(ipcParametricData, metaData);
        }

        if(metaData["pitch2"]() === null) {
            this.updatePitch2(ipcParametricData, metaData);
        }
    } else {
        this.updatePitch1(ipcParametricData, metaData);
        this.updatePitch2(ipcParametricData, metaData);
    }

    ///////////////
    //   Body    //
    ///////////////

    this.updateBody(ipcParametricData, metaData, override);

    ////////////////////
    //   Lead span    //
    ////////////////////

    this.updateLeadSpan(ipcParametricData, metaData, override);

    ////////////////////////
    //   Mounting type    //
    ////////////////////////

    this.updateMountingType(ipcParametricData, metaData, override);
};

module.exports = MetaDataUpdateHelper;

MetaDataUpdateHelper.updatePinCount = function(ipcParametricData, metaData) {
    var pinCount;

    if(ipcParametricData instanceof IpcDataModel.QuadRowPackageData) {
        pinCount = 2 * parseInt(ipcParametricData.horizontalPadCount()) + 2 * parseInt(ipcParametricData.verticalPadCount());
    } else if(ipcParametricData instanceof IpcDataModel.BgaData) {
        pinCount = parseInt(ipcParametricData.horizontalPadCount()) * parseInt(ipcParametricData.verticalPadCount());
    } else if(ipcParametricData instanceof IpcDataModel.DualRowPackageData || ipcParametricData instanceof IpcDataModel.DualRowPackageWithThermalPadData) {
        //for DPAK package with middle lead trimmed pin count must be decremented by one
        if(ipcParametricData.constructor === IpcDataModel.ToDpakData && ipcParametricData.hasTruncatedPin()) {
            pinCount = parseInt(ipcParametricData.horizontalPadCount() - 1);
        } else {
            pinCount = parseInt(ipcParametricData.horizontalPadCount());
        }
    } else if(ipcParametricData instanceof IpcDataModel.IpcPthPadGeneratorData) {
        if(ipcParametricData instanceof IpcDataModel.HeaderData) {
            pinCount = parseInt(ipcParametricData.horizontalPadCount()) * parseInt(ipcParametricData.verticalPadCount());
        } else {
            pinCount = parseInt(ipcParametricData.horizontalPadCount());
        }
    }

    metaData["pins"](pinCount);
};

//TODO: populate if default package name used?
MetaDataUpdateHelper.updateNameDescriptionSummary = function(name, description, summary, metaData, override) {
    if(!override) {
        //in EAGLE summary is displayed before description
        //if description is empty in EAGLE user expects it not to be populated in non override case
        //populate if both field are empty
        if(!metaData.description() && !metaData.summary()) {
            if(summary) metaData.summary(summary);
            if(description) metaData.description(description);
        }
    } else {
        if(name) metaData.name(name);
        if(description) metaData.description(description);
        if(summary) metaData.summary(summary);
    }
};

MetaDataUpdateHelper.updateIPCName = function(ipcName, metaData) {
    if(ipcName) metaData["ipcName"](ipcName);
};

MetaDataUpdateHelper.updateIPCFamily = function(ipcParametricData, metaData) {
    metaData["ipcFamily"](IpcNameHelper.getIPCFamilyForMetaData(ipcParametricData));
};

MetaDataUpdateHelper.updatePitch1 = function(ipcParametricData, metaData) {
    if(ipcParametricData instanceof IpcDataModel.HeaderData) {
        if(ipcParametricData.verticalPadCount() == 1) {
            if(ipcParametricData.horizontalPadCount() > 1) { //store other pitch in this metadata if other pad count is more than 1
                metaData["pitch"](ipcParametricData.horizontalPinPitch());
            } else {
                metaData["pitch"](null);
            }
        } else {
            if (ipcParametricData instanceof IpcDataModel.AxialData) {
                metaData["pitch"](ipcParametricData.getPinPitch());
            } else {
                metaData["pitch"](ipcParametricData.verticalPinPitch());
            }
        }
    } else if (ipcParametricData instanceof IpcDataModel.AxialData) {
        metaData["pitch"](ipcParametricData.getPinPitch());
    } else {
        metaData["pitch"](ipcParametricData.verticalPinPitch());
    }
};

MetaDataUpdateHelper.updatePitch2 = function(ipcParametricData, metaData) {
    //for header packages update pitch2 for 1xn and nx1 packages even both pitch are equal
    if(ipcParametricData instanceof IpcDataModel.HeaderData) {
        if(ipcParametricData.horizontalPadCount() == 1) {
            metaData["pitch2"](null);
        } else {
            if(ipcParametricData.verticalPadCount() == 1) {
                metaData["pitch2"](null);
            } else if(ipcParametricData.verticalPadCount() > 1) { //store metadata if other pad count is more than 1
                metaData["pitch2"](ipcParametricData.horizontalPinPitch());
            }
        }
    } else if(ipcParametricData.horizontalPinPitch && ipcParametricData.horizontalPinPitch() !== ipcParametricData.verticalPinPitch()) {
        metaData["pitch2"](ipcParametricData.horizontalPinPitch());
    }
};

MetaDataUpdateHelper.updateBody = function(ipcParametricData, metaData, override) {
    var isPackageRotated = ipcParametricData.constructor === IpcDataModel.SodData
                        || ipcParametricData.constructor === IpcDataModel.SodflData
                        || ipcParametricData.constructor === IpcDataModel.ChipData
                        || ipcParametricData.constructor === IpcDataModel.MoldedBodyData
                        || ipcParametricData.constructor === IpcDataModel.CrystalData
                        || ipcParametricData.constructor === IpcDataModel.CrystalHC49Data
                        || ipcParametricData.constructor === IpcDataModel.OscillatorCornerConcaveData
                        || ipcParametricData.constructor === IpcDataModel.Dfn2Data
                        || ipcParametricData.constructor === IpcDataModel.Dfn3Data
                        || ipcParametricData.constructor === IpcDataModel.Dfn4Data
                        || ipcParametricData.constructor === IpcDataModel.PlccData
                        || ipcParametricData.constructor === IpcDataModel.AxialData
    var bodyLength = null;
    var bodyWidth = null;
    var bodyHeight = null;

    if(!override) {
        if(metaData["bodyLength"]() === null) {
            if(isPackageRotated) {
                bodyLength = (ipcParametricData.bodyWidthMax() + ipcParametricData.bodyWidthMin()) / 2;
            } else {
                bodyLength = (ipcParametricData.bodyLengthMax() + ipcParametricData.bodyLengthMin()) / 2;
            }
        }

        if(metaData["bodyWidth"]() === null) {
            if(isPackageRotated) {
                bodyWidth = (ipcParametricData.bodyLengthMax() + ipcParametricData.bodyLengthMin()) / 2;
            } else {
                bodyWidth = (ipcParametricData.bodyWidthMax() + ipcParametricData.bodyWidthMin()) / 2;
            }
        }

        if(metaData["height"]() === null) {
            if(ipcParametricData instanceof IpcDataModel.HeaderStraightData) {
                bodyHeight = ipcParametricData.bodyHeightMax() + ipcParametricData.terminalPostLength();
            } else {
                bodyHeight = ipcParametricData.bodyHeightMax();
            }
        }
    } else {
        if(isPackageRotated) {
            bodyLength = (ipcParametricData.bodyWidthMax() + ipcParametricData.bodyWidthMin()) / 2;
            bodyWidth = (ipcParametricData.bodyLengthMax() + ipcParametricData.bodyLengthMin()) / 2;
        } else {
            bodyLength = (ipcParametricData.bodyLengthMax() + ipcParametricData.bodyLengthMin()) / 2;
            bodyWidth = (ipcParametricData.bodyWidthMax() + ipcParametricData.bodyWidthMin()) / 2;
        }

        if(ipcParametricData instanceof IpcDataModel.HeaderStraightData) {
            bodyHeight = ipcParametricData.bodyHeightMax() + ipcParametricData.terminalPostLength();
        } else {
            bodyHeight = ipcParametricData.bodyHeightMax();
        }
    }

    metaData["bodyLength"](bodyLength);
    metaData["bodyWidth"](bodyWidth);
    metaData["height"](bodyHeight);
};

//for qfp packages lead spans span 1 and span 2 are along y (vertical) and x (horizontal) directions respectively
//for plcc packages span 1 and span 2 are along x (horizontal) and y (vertical) directions respectively
//for dual packages (soic, sod, etc) only one lead span is available and its along x (horizontal) directions
//note: for some packages leadspans are not applicable (e.g., chip, melf, qfn, etc)
MetaDataUpdateHelper.updateLeadSpan = function(ipcParametricData, metaData, override) {
    var leadSpan1 = null;
    var leadSpan2 = null;

    function isPackageWithLeadSpan() {
        return (ipcParametricData.constructor !== IpcDataModel.BgaData
        && ipcParametricData.constructor !== IpcDataModel.ChipData
        && ipcParametricData.constructor !== IpcDataModel.MoldedBodyData
        && ipcParametricData.constructor !== IpcDataModel.OscillatorCornerConcaveData
        && ipcParametricData.constructor !== IpcDataModel.Dfn2Data
        && ipcParametricData.constructor !== IpcDataModel.Dfn3Data
        && ipcParametricData.constructor !== IpcDataModel.Dfn4Data
        && ipcParametricData.constructor !== IpcDataModel.MelfData
        && ipcParametricData.constructor !== IpcDataModel.ChipArrayTwoSideConvexData
        && ipcParametricData.constructor !== IpcDataModel.ChipArrayTwoSideFlatConcaveData
        && ipcParametricData.constructor !== IpcDataModel.ChipArrayFourSideFlatConcaveData
        && ipcParametricData.constructor !== IpcDataModel.QfnData
        && ipcParametricData.constructor !== IpcDataModel.AxialData
        && ipcParametricData.constructor !== IpcDataModel.HeaderStraightData
        && ipcParametricData.constructor !== IpcDataModel.HeaderRightAngleData
        && ipcParametricData.constructor !== IpcDataModel.HeaderStraightSocketData
        && ipcParametricData.constructor !== IpcDataModel.HeaderRightAngleSocketData
        && ipcParametricData.constructor !== IpcDataModel.SonData
        && ipcParametricData.constructor !== IpcDataModel.RadialRoundData
        && ipcParametricData.constructor !== IpcDataModel.RadialLedRoundData
        && ipcParametricData.constructor !== IpcDataModel.CrystalHC49Data);
    };
    
    if(ipcParametricData instanceof IpcDataModel.QuadRowPackageData) {
        if(ipcParametricData.constructor !== IpcDataModel.QfnData) {
            if(!override) {
                if(metaData["leadSpan"]() === null) {
                    if(ipcParametricData.constructor == IpcDataModel.PlccData) {
                        leadSpan1 = (ipcParametricData.horizontalLeadToLeadSpanMax() + ipcParametricData.horizontalLeadToLeadSpanMin()) / 2;
                    } else {
                        leadSpan1 = (ipcParametricData.verticalLeadToLeadSpanMax() + ipcParametricData.verticalLeadToLeadSpanMin()) / 2;
                    }
                }

                if(metaData["leadSpan2"]() === null) {
                    if(ipcParametricData.constructor == IpcDataModel.PlccData) {
                        leadSpan2 = (ipcParametricData.verticalLeadToLeadSpanMax() + ipcParametricData.verticalLeadToLeadSpanMin()) / 2;
                    } else {
                        leadSpan2 = (ipcParametricData.horizontalLeadToLeadSpanMax() + ipcParametricData.horizontalLeadToLeadSpanMin()) / 2;
                    }
                }
            } else {
                if(ipcParametricData.constructor == IpcDataModel.PlccData) {
                    leadSpan1 = (ipcParametricData.horizontalLeadToLeadSpanMax() + ipcParametricData.horizontalLeadToLeadSpanMin()) / 2;
                    leadSpan2 = (ipcParametricData.verticalLeadToLeadSpanMax() + ipcParametricData.verticalLeadToLeadSpanMin()) / 2;
                } else {
                    leadSpan1 = (ipcParametricData.verticalLeadToLeadSpanMax() + ipcParametricData.verticalLeadToLeadSpanMin()) / 2;
                    leadSpan2 = (ipcParametricData.horizontalLeadToLeadSpanMax() + ipcParametricData.horizontalLeadToLeadSpanMin()) / 2;
                }
            }
        }
    } else if(isPackageWithLeadSpan()) {
        if(ipcParametricData.constructor === IpcDataModel.DipData) {
            if(!override) {
                if(metaData["leadSpan"]() === null) {
                    leadSpan1 = ipcParametricData.leadSpan();
                }
            } else {
                leadSpan1 = ipcParametricData.leadSpan();
            }
        } else if(ipcParametricData.constructor === IpcDataModel.CrystalData || ipcParametricData.constructor === IpcDataModel.AluminumElectrolyticData) {
            if(!override) {
                if(metaData["leadSpan"]() === null) {
                    if (ipcParametricData.optionalDimension() === IpcDataModel.ComponentAttribute.optionalDimensionInput["Optional_D"]) {
                        leadSpan1 = (ipcParametricData.terminalGapMin() + ipcParametricData.terminalGapMax()) / 2 + ipcParametricData.padWidthMin() + ipcParametricData.padWidthMax();
                    } else {
                        leadSpan1 = (ipcParametricData.horizontalLeadToLeadSpanMax() + ipcParametricData.horizontalLeadToLeadSpanMin()) / 2;
                    }   
                }
            } else {
                if (ipcParametricData.optionalDimension() === IpcDataModel.ComponentAttribute.optionalDimensionInput["Optional_D"]) {
                    leadSpan1 = (ipcParametricData.terminalGapMin() + ipcParametricData.terminalGapMax()) / 2 + ipcParametricData.padWidthMin() + ipcParametricData.padWidthMax();
                } else {
                    leadSpan1 = (ipcParametricData.horizontalLeadToLeadSpanMax() + ipcParametricData.horizontalLeadToLeadSpanMin()) / 2;
                } 
            }
        } else {
            if(!override) {
                if(metaData["leadSpan"]() === null) {
                    leadSpan1 = (ipcParametricData.horizontalLeadToLeadSpanMax() + ipcParametricData.horizontalLeadToLeadSpanMin()) / 2;
                }
            } else {
                leadSpan1 = (ipcParametricData.horizontalLeadToLeadSpanMax() + ipcParametricData.horizontalLeadToLeadSpanMin()) / 2;
            }
        }
    }

    metaData["leadSpan"](leadSpan1);
    metaData["leadSpan2"](leadSpan2);
};

MetaDataUpdateHelper.updateMountingType = function(ipcParametricData, metaData, override) {
    var mountingType = null;

    if(ipcParametricData instanceof IpcDataModel.IpcSmdPadGeneratorData) {
        mountingType = MetaDataProperties["footprint"]["mountingType"].enums.SMD.val;
    } else if(ipcParametricData instanceof IpcDataModel.IpcPthPadGeneratorData) {
        mountingType = MetaDataProperties["footprint"]["mountingType"].enums.PTH.val;
    }

    if(!override) {
        if(metaData["mountingType"]() === null) {
            metaData["mountingType"](mountingType);
        }
    } else {
        metaData["mountingType"](mountingType);
    }
};
